module.exports = __webpack_public_path__ + "media/images/social_svgs/facebook-0c0ba7c74a1dc95d06804e4dac2e4ebb.svg";